<template>
   <div class="warpNavlan" ref="brandRef">
        <div class="box-one">
          <div class="center"  ref="gasp-title">
            <div><span>品牌优势</span></div>
          </div>
        </div>
        <div class="box-two" ref="gasp-box">
          <div class="context">
            <div class="context-one">
              <div class="context-box">
                <div class="context-one-item">
                  <div class="item-one"></div>
                  <div class="item-two">
                    商城首页
                  </div>
                </div>
                <div class="context-one-item">
                  <div class="item-one"></div>
                  <div class="item-two">
                    繁淼充电桩
                  </div>
                </div>
                <div class="context-one-item">
                  <div class="item-one"></div>
                  <div class="item-two">
                    嘉马商城
                  </div>
                </div>
                <div class="context-one-item">
                  <div class="item-one"></div>
                  <div class="item-two">
                    智慧消防
                  </div>
                </div>
                <div class="context-one-item">
                  <div class="item-one"></div>
                  <div class="item-two">
                    商家入驻
                  </div>
                </div>
              </div>
            </div>
            <div class="context-two">
              <div class="title" style="justify-content: flex-start;padding-left: 50px;">
                <span>我们的优势</span>
              </div>
              <div class="deail">
                <div class="text" style="display: flex;justify-content: flex-start;width: 100%;">
                  <!-- <pre>
                    1.富有远见及强大执行能力的管理层
                    2.专有团队和创新技术
                    3.助力商家取得成功的多元化解决方案
                    4.一站式服务
                    5.独特即时配送网络
                    6.增加店铺曝光度
                    7.创建多种营销活动
                    8.提高产品知名度和影响力
                  </pre> -->
                  <ul type="cir" class="text-ol">
                    <li>富有远见及强大执行能力的管理层</li>
                    <li>专有团队和创新技术</li>
                    <li>助力商家取得成功的多元化解决方案</li>
                    <li>一站式服务</li>
                    <li>独特即时配送网络</li>
                    <li>增加店铺曝光度</li>
                    <li>增加店铺曝光度</li>
                    <li>增加店铺曝光度</li>
                  </ul>
                </div>
                <div class="slider">
                  <div class="slider-bot"></div>
                  <div class="slider-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
   </div>
</template>
<script>
import { gsap } from 'gsap'
export default {
  name: 'child',
  data(){
    return{
    }
  },
  mounted() { 
    let observer = new IntersectionObserver((enter)=>{
      if(enter[0].isIntersecting){
        gsap.from(this.$refs['gasp-title'],{
          y:'-100%',
          ease: "power2.out",
          duration:2
        })
        gsap.from(this.$refs['gasp-box'],{
          x:-(window.innerWidth || document.documentElement.clientWidth),
          duration: 2,
          ease:'power2.out'
        })
        observer.unobserve(this.$refs.brandRef)
      }
    },{
      root: null,
      threshold: 0.3
    })
    observer.observe(this.$refs.brandRef)
  },
  methods:{
   
  }
}
</script>
<style lang="scss" scoped>
    .warpNavlan{
      width: 100%;
      height: 1080px;
      background: #FFFFFF;
      position: relative;
      box-sizing: border-box;
      padding-top: 106px;
      .box-one{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 83px;
        .center{
          width: 700px;
          height: 98px;
          background-image: url('../../../assets/brand.png');
          background-size: 100% 100%;
          div{
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: flex-end;

            span{
              font-size: 40px;
              font-family: Alibaba_Bold;
              color: #333333;
              line-height: 56px;
            }
          }
        }
        // 
      }
      .box-two{
        display: flex;
        justify-content: center;
        .context{
          width: 1200px;
          height: 686px;
          display: flex;
          .context-one{
            width: 432px;
            height: 100%;
            background-image: url('../../../assets/brand-context-bg.png');
            background-size: 100% 100%;
            box-sizing: border-box;
            padding-top: 289px;
            padding-left: 40px;
            .context-box{
              display: grid;
              grid-template-columns: 1fr 1.6fr;
              .context-one-item{
                display: flex;
                align-items: center;
                margin-bottom: 30px;
                .item-one{
                  width: 4px;
                  height: 4px;
                  background: rgba(255,255,255,0.9);
                  border-radius: 50%;
                  margin-right: 10px;
                }
                .item-two{
                  font-size: 16px;
                  font-family:Alibaba_Midum;
                  color: #FFFFFF;
                  line-height: 22px;
                }
              }
            }
          }
          .context-two{
            width: calc(100% - 432px);
            height: 100%;
            background-image: url('../../../assets/brand-context-bg2.png');
            background-size: 100% 100%;
            box-sizing: border-box;
            padding-top: 100px;
            .title{
              display: flex;
              justify-content: flex-end;
              margin-right: 81px;
              margin-bottom: 60px;
              span{
                font-size: 20px;
                font-family: Alibaba_Bold;
                font-weight: 600;
                color: #367CFF;
                line-height: 28px;
              }
            }
            .deail{
              display: flex;
              justify-content: flex-end;
              padding-right: 60px;
              padding-left: 50px;
              box-sizing: border-box;
              .text{
                // width: 607px;
                // height: 377px;
                font-size: 14px;
                font-family:Alibaba_Regular;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                ul{
                  float: left;
                  column-count: 2;
                  column-gap: 80px;
                  margin-left: 75px;
                  li{
                    width: 260px;
                    margin-bottom: 30px; 
                    font-size: 16px;
                  }
                }
              }
              .slider{
                margin-left: 47px;
                display: flex;
                .slider-bot{
                  width: 4px;
                  height: 44px;
                  background: #367CFF;
                }
                .slider-line{
                  width: 1px;
                  height: 436px;
                  background: #DEE3E6;
                }
              }
            }
          }
        }
      }
    }
</style>

